import { ELSPageLoader } from '@els/els-ui-common-react';
import { useSelector } from 'react-redux';
import { Redirect } from 'react-router';
import { RoutePath } from 'constants/app.constant';
import useWguExperience from 'reports/cw/hooks/shared/useWguExperience';
import { courseSelectors } from 'reports/cw/redux/ducks/courses';
// The WGU experience is search-only, so every other report route sends the instructor back to the CW home (the student search).
var withWguRouteGuard = function (WrappedComponent) {
    var GuardedComponent = function (props) {
        var isWguExperience = useWguExperience();
        var courseSectionInfo = useSelector(courseSelectors.getCourseSectionInfo);
        // Only hold the route while the course type genuinely can't be determined yet. Gating on `isCourseFetching` would unmount the page on every course refetch.
        if (!courseSectionInfo) {
            return <ELSPageLoader />;
        }
        if (isWguExperience) {
            return <Redirect to={RoutePath.cwIns}/>;
        }
        return <WrappedComponent {...props}/>;
    };
    GuardedComponent.displayName = "withWguRouteGuard(".concat(WrappedComponent.displayName || WrappedComponent.name || 'Component', ")");
    return GuardedComponent;
};
export default withWguRouteGuard;
